import BaseApi from '@lumapps/base-api';

const api = new BaseApi({ path: 'drive/files' });

const insertFile = (data) => api.post('insert', data, {});

export { insertFile };
